import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillFacebook,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Welcome to my world of technology and innovation! 🌐
              <br />
              <br />
              I am a passionate developer fluent in languages such as
              <i>
                <b className="purple"> Kotlin, JavaScript, and Go.</b>
              </i>
              <br />
              <br />
              My expertise lies in creating cutting-edge &nbsp;
              <i>
                <b className="purple">Web Technologies and Products</b>
              </i>
              &nbsp; and diving into the realm of{" "}
              <b className="purple">Blockchain technology.</b>
              <br />
              <br />
              I specialize in developing robust applications using
              <b className="purple"> Node.js</b> and modern
              <i>
                <b className="purple"> JavaScript libraries and frameworks</b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i>
              . My goal is to transform your ideas into functional, scalable, and high-performing solutions.
              <br />
              <br />
              <i>
                <b className="purple"> Here are some of the services I offer:</b>
              </i>
              <ul>
                <li>Web Development</li>
                <li>Project Management</li>
                <li>Search Engine Optimization (SEO)</li>
                <li>Database Development</li>
                <li>User Experience Design (UED)</li>
                <li>Technical Support</li>
                <li>Mobile Application Development</li>
                <li>SaaS Development</li>
              </ul>
              <br />
              <i>
                <b className="purple"> Let’s work together to build something amazing!</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" style={{ height: '25rem', maxWidth: '100%' }} alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/younespro1337"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/younesraymond1"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/younes-raymond-188a40241/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/profile.php?id=100083186589480"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillFacebook />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
